<div class="scrollable-component">
	<div class="container">
		<div class="row">
			<div class="col-12">
				<cv-generic-integration-base-table
					[label]="label"
					[modalSize]="modalSize"
					[model]="model.model"
					[formBuilderConfig]="model.formBuilderConfig"
					[extraData]="extraData"
					[params]="deliveryAssetsParams"
					[callBacks]="model.callBacks">
				</cv-generic-integration-base-table>
			</div>
		</div>
	</div>
</div>
